export const qfHistoryAdapter = (props) => {
	if (props?.approveQfHistory) {
		const result = props?.approveQfHistory?.filter(
			(record) => record.code_internal === props?.recipeInfo?.code_internal?.toString() && record.trx_id === props?.trx_id,
		);
		return result;
	}
	return null;
};
